import { ArticleWithCreativesQuery } from './__generated__/ArticleWithCreativesQuery';
import { useLazyQuery } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { ARTICLE_WITH_CREATIVES_QUERY } from './articleWithCreatives.query';

export const useArticleWithCreativesLazyQuery = () => {
  return useLazyQuery<ArticleWithCreativesQuery>(ARTICLE_WITH_CREATIVES_QUERY, {
    client: kmsClient,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });
};
